import { isStaticPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { staticTabReloadedThunk } from 'state/static/staticForm.thunks';

export function fillTabContentInNewStaticScreenEpic(): EpicWithThunk {
  return (action$, _state$) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ tabContent }) => isStaticPersistedTabContent(tabContent)),
      mergeMap(({ tabId, tabContent }) => {
        if (!isStaticPersistedTabContent(tabContent)) {
          return EMPTY;
        }

        return of(staticTabReloadedThunk(tabId, tabContent));
      }),
    );
}
